
 import { lazyLoad } from 'utils/loadable';

 export const ProfileSetup = lazyLoad(
   () => import('./index'),
   module => module.ProfileSetup,
 );
 